export class Nshock {

    _machVal!: number;
    _gammaVal!: number;
    _m1!: number;
    _m2!: number;
    _p2p1!: number;
    _t2t1!: number;
    _dva1!: number;
    _pt2pt1!: number;
    _pt2p1!: number;

    constructor() {
        this._machVal = 0;
        this._gammaVal = 1.4;
        this._m1 = 0;
        this._m2 = 0;
        this._p2p1 = 0;
        this._t2t1 = 0;
        this._dva1 = 0;
        this._pt2p1 = 0;
        this._pt2p1 = 0;
    }


    nShockCalc(ga:number, ma1:number) {
        let g = Number(ga);
        let m = Number(ma1);
        let gm1 = g - 1;
        let gp1 = g +1;
        let m12 = Math.pow(Number(ma1), 2);

        if (m == Infinity) {
            this._m2 = .37796;
            this._p2p1 = Infinity;
            this._t2t1 = Infinity;
            this._dva1 = Infinity;
            this._pt2pt1 = 0.0;
            this._pt2p1 = Infinity;
        } else {

           // M_2
            if (this._m2 === 0) {
                this._m2 = Math.sqrt( (gm1*m12 + 2) / ( 2* g * m12 - (g - 1)) );
            }

            let ma2 = this._m2;

            // p2 / p1
            if (this._p2p1 === 0) {
                this._p2p1 = (2*g*m12  - gm1) / gp1;
            }

            // T2 / T1
            if (this._t2t1 === 0) {
                let ma2_2:number = Math.pow(ma2, 2);
                this._t2t1 = (2 + gm1*m12) / (2 + gm1*ma2_2);
            }
            
         

            // deltaV / a1  
            if (this._dva1 === 0) {
                this._dva1 = (2/gp1) * ((m12 - 1) / m);
            }

            // pt2 / pt1
            if (this._pt2p1 === 0) {
                let l = ( ( gp1/2 ) * m12 ) / ( 1 + ((gm1/2) * m12));
                let r = ((2*g / gp1) * m12) - (gm1/gp1);    
                this._pt2pt1 = Math.pow(l, g/gm1) * Math.pow(r, 1/(1-g));
            }

            // pt2 / p1
            if (this._pt2p1 === 0) {
                let num =  Math.pow((.5* gp1 * m12), g/gm1 );
                let den = Math.pow( ((2*g*m12)/gp1) - (gm1/gp1), 1/gm1); 
                this._pt2p1 = num/den;
            }
        }
    }

    get machVal(): number {
        return this._machVal;
    }

    get m1(): number {
        return this._m1;
    }

    get m2(): number {
        return this._m2;
    }

    get p2p1(): number {
        return this._p2p1;
    }

    get t2t1(): number {
        return this._t2t1;
    }


    get gammaVal(): number {
        return this._gammaVal;
    }

    get dva1(): number {
        return this._dva1;
    }


    get pt2pt1(): number {
        return this._pt2pt1;
    }

    get pt2p1(): number {
        return this._pt2p1;
    }


    set gammaVal(value) {
        this._gammaVal = value;
    }

    set dva1(value) {
        this._dva1 = value;
    }

    set machVal(value) {
        this._machVal = value;
    }

    set m1(value) {
        this._m1 = value;
    }

    set m2(value) {
        this._m2 = value;
    }

    set p2p1(value) {
        this._p2p1 = value;
    }

    set t2t1(value) {
        this._t2t1 = value;
    }
}
